var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.779,
    height: 30.563,
    viewBox: "0 0 34.779 30.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visit-icon",
    transform: "translate(-2.289 -3.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7322",
    "data-name": "Path 7322",
    d: "M13.352,3.34V28.623a3.48,3.48,0,0,0-1.641.423L7.565,31.411c-2.894,1.659-5.276.282-5.276-3.07V11.174A3.9,3.9,0,0,1,4.071,8.121l7.64-4.376A3.694,3.694,0,0,1,13.352,3.34Z",
    transform: "translate(0 0.001)",
    fill: "#14294a",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7323",
    "data-name": "Path 7323",
    d: "M21.211,8.616V33.9a3.727,3.727,0,0,1-1.694-.318l-9.263-4.64a3.727,3.727,0,0,0-1.694-.318V3.341a3.727,3.727,0,0,1,1.694.318L19.517,8.3A3.727,3.727,0,0,0,21.211,8.616Z",
    transform: "translate(4.794 0)",
    fill: "#14294a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7324",
    "data-name": "Path 7324",
    d: "M26.793,8.125V25.292a3.9,3.9,0,0,1-1.782,3.052l-7.64,4.376a3.694,3.694,0,0,1-1.641.406V7.842a3.48,3.48,0,0,0,1.641-.423l4.146-2.364C24.411,3.4,26.793,4.772,26.793,8.125Z",
    transform: "translate(10.274 0.774)",
    fill: "#14294a",
    opacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitIcon);
export default __webpack_public_path__ + "static/media/visit-icon.5211ed4b2943b80b0387f79dba3f7d1d.svg";
export { ForwardRef as ReactComponent };